<template>
  <v-app id="mainAPP">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ=" crossorigin="anonymous" />
    <!-- <font-awesome-icon :icon="['fab', 'font-awesome']" /> -->
    <!-- <font-awesome-icon icon="angle-left" /> -->
    <!--<i class="fab fa-apple"></i>-->
    <div id="content" >
  <b-navbar type="dark" variant="light">
    <b-navbar-brand href="./main"><img class="logo" src="./assets/img/logo-new-transparent.png" width="200" height="200" alt="SMART CITY INFRALAB"></b-navbar-brand>
    <p id="project-name">โครงการวิจัยและพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</p>
  </b-navbar>
  <b-navbar toggleable="lg" type="dark" style="background-color: #0080D5;"> <!--variant="info" 0080D5 -->
    <b-navbar-brand href="/main"> SMART CITY INFRALAB</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="/main">หน้าหลัก</b-nav-item>
        <b-nav-item href="/news">ประชาสัมพันธ์</b-nav-item>
        <b-nav-item-dropdown text="โครงการวิจัย">
          <b-dropdown-item href="/project/01">การพัฒนาพื้นที่กิจกรรมสาธารณะเมืองเพื่อพัฒนาให้สอดคล้องกับเมืองอัจฉริยะสงขลา</b-dropdown-item>
          <b-dropdown-item href="/project/02">ระบบเตือนภัยมลพิษทางอากาศสำหรับเทศบาลคนสงขลาเมืองอัจฉริยะ</b-dropdown-item>
          <b-dropdown-item href="/project/03">ระบบจราจรอัจฉริยะสำหรับสงขลาเมืองน่าอยู่</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item href="/event">กิจกรรม</b-nav-item>
        <b-nav-item href="/about">เกี่ยวกับเรา</b-nav-item>
        <b-nav-item href="/contact-us">ติดต่อ</b-nav-item>
      </b-navbar-nav>
      
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        
        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>

        <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="/EN">EN</b-dropdown-item>
          <b-dropdown-item href="/main">TH</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

    <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>

    <v-footer
      v-bind="localAttrs"
      :padless="padless"
      color="indigo"
    >

      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" sm="4">
            <div align="left"><img class="logo" src="./assets/img/logo-new-transparent-white.png" width="200" height="200" alt="SMART CITY INFRALAB"></div>
          </v-col>
          <v-col cols="12" sm="4">
            <div align="left">
            <span class="white--text" align="left">
                <h4><div>Smart City Infralab</div></h4> 
                <div>มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย สงขลา</div>
                <div>2/4 ถนนราชดำเนินนอก</div>
                <div>ต.บ่อยาง อ.เมืองสงขลา จ.สงขลา 90000</div>
                <div>Facebook : City infrastructure lab</div>
                <div>E-mail : cityinfralab@gmail.com</div>
                <div>โทรศัพท์ : 0-7431-7168 </div>
            </span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" align="right">
            <div align="left">
            <v-row no-gutters>
              <a href="https://www.facebook.com/City-infrastructure-lab-104633281226873/" target="_blank"><span class="white--text">Facebook Page : City infrastructure lab</span></a>
            </v-row>
            <v-row no-gutters>
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCity-infrastructure-lab-104633281226873&tabs=timeline&width=500&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="130" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
            </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <span class="white--text">&copy; {{ new Date().getFullYear() }} SMART CITY INFRALAB โครงการวิจัยและพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</span>
    </v-footer>
    </div>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    metaInfo: {
      title: 'Home',
      titleTemplate: '%s | SMART CITY INFRALAB RUTS โครงการวิจัยและพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา',
      htmlAttrs: { lang: 'th' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
    props: {
      source: String,
    },
    data () {
      return {
        drawer: null,
        tab: null,
      }
    },
    
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Prompt');

html, body {
  font-family: 'Prompt', sans-serif;
}

#mainAPP {
  font-family: Prompt, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  max-width: 1440px;
  margin: auto;
}
#content {
  
}
#project-name {
  font-size:2vw;
  color: #0080D5;
}
.share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    color: #FFFFFF;
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    color: #FFFFFF;
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>
